import { Injectable } from '@angular/core';
import {  ModalController } from '@ionic/angular';

import * as JQuery from 'jquery';
import { TourGuideComponent } from '../../components/tour-guide/tour-guide';
/*
  Generated class for the TourGuideManagerProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TourGuideManagerProvider {
  public tips : Array<Tip>;
  constructor(private  modalCtrl: ModalController) {
    this.tips = [];
//    this.initTips();
  }
  introduceChatDictionary(){
      
      
  }
  introduceMoreContent() : Promise<boolean>{
    return new Promise((resolve)=>{
        if(this.isReady()){   
            this.initHasMoreContentTipps();
            this.guide().then((isUserLearned)=>{
                if(isUserLearned){
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            });
        }
    });
  }
  isReady(){
      return this.tips.length == 0;
  }
  getTip(){
      return this.tips.pop();
  }
  createTip(text : string ,element? : JQuery,width?:number,height?:number){
      return {'text': text, 'element':element,width,height};
  }
  initSendTips(){

    
  }
  initInputChatTips(){
        let tipText = "اینجا می شه به فارسی یا آلمانی یه لغت نوشت مثلا می خوایم بدونیم معنی کلمه ";
        tipText+=" buch ";
        tipText+=" به فارسی چی می شه ";

        this.tips.push(this.createTip( 'به فرهنگ لغت بایادیک خوش اومدین، روی صفحه کلیک کنید تا نحوه ی استفاده رو بهتون آموزش بدم'));
  }
  initMessageTips(){
      this.tips.push(this.createTip("وقتی روی این دکمه کلیک کنی، می تونی این کلمه رو حذف کنی یا به جعبه لایتنر که برای ذخیره و یادگیری لغات هست اضافه کنی", $(".moreBtn")))
    //   this.tips.push(this.createTip("با فشاردادن این دکمه هم تلفظ لغت رو می شه شنید", $(".speechIcon")))
    //   this.tips.push(this.createTip("بیشتر کلمه ها مثال دارن که با کلیک کردن روی این دکمه می تونی ببینیشون", $(".conjugateNow"),30,30))
    //   this.tips.push(this.createTip("همینطور که میشه دید، کلمه با آرتیکل جنسیت خودش اینجا نوشته می شه", $(".artikel").first()))
    //   this.tips.push(this.createTip("هورا لغتی که نوشتیم ترجمه شد. حالا سعی می کنم جزئیات ترجمه رو بهت بگم", $("message").last()))
  }
  initHasMoreContentTipps(){
      this.tips.length = 0;
      this.tips.push(this.createTip("وقتی این جا رو لمس کنی همه ی لغات دیده می شن",$(".openMoreHandle").last()));
      this.tips.push(this.createTip("یه نکته بگم؟ بعضی لغات تعداد معنی های زیادی دارن، ولی در مرحله اول همگی با هم دیده نمی شن"));
  }
  guide() : Promise<boolean>{
    return new Promise(async (resolve)=>{
        let tourGuide = await this.modalCtrl.create({
            component: TourGuideComponent
        });
        tourGuide.present();
        tourGuide.onDidDismiss().then(()=>{
            resolve(true);
        });
    });
  }

}
export interface Tip {
    element : JQuery,
    text : string,
    width?: number,
    height?: number
    
}